export function SealMark({ size = 28 }: { size?: number }) {
  return (
    <span
      className="relative inline-grid place-items-center rounded-full border border-gold-500"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span
        className="absolute rounded-full border border-gold-400"
        style={{ inset: Math.max(3, size * 0.14) }}
      />
      <span
        className="block rounded-full bg-gold-300"
        style={{
          width: Math.max(4, size * 0.22),
          height: Math.max(4, size * 0.22),
          boxShadow: '0 0 10px #c9a55c',
        }}
      />
    </span>
  );
}
